import classNames from 'classnames';
import { ReactNode } from 'react';

import { useCollapsable } from '../../hooks/ui/useCollapsable';
import HeightToggle from '../HeightToggle/HeightToggle';

import styles from './CardContent.module.css';

type CardContentProps = {
    children: ReactNode;
};

const CardContent = ({ children }: CardContentProps) => {
    const { collapsed } = useCollapsable();
    const classes = classNames(styles.Root, {
        [styles.collapsed]: collapsed,
    });

    return (
        <HeightToggle show={!collapsed}>
            <div className={classes}>{children}</div>
        </HeightToggle>
    );
};

export default CardContent;
